
function singletonMaker(key, klass) {
  if (!window.sparta) {
    window.sparta = {};
  }

  const KEY = Symbol.for(key);
  const globalSymbols = Object.getOwnPropertySymbols(sparta);
  const hasKey = (globalSymbols.indexOf(KEY) > -1);

  if (!hasKey) {
    sparta[KEY] = new klass();
  }
  Object.seal(sparta[KEY]);
  return sparta[KEY];
}

export default singletonMaker;
